module.exports = __webpack_public_path__ + "img/expedia.3318431f.svg";